import styled, { css } from 'styled-components';
import { variants, th } from 'style/theme';

const P = styled.p`
  color: ${th('colors.primaryText')};
  margin: 0;
  line-height: 1.4;

  ${variants('variant', {
    subheader: css`
      color: ${th('colors.transparentWhite.7')};
    `,
    dark: css`
      color: ${th('colors.black')};
    `
  })}
`;

export default P;
